import {Base} from '../../common/model/base.model';

export class Stradario extends Base {

  constructor(protected id: number,
              public provincia: string,
              public comune: string,
              public codiceComune: number,
              public localita: string,
              public dug: string,
              public denominazione: string
  ) {
    super(id);
  }

  public getLabel() {
    return this.dug + ' ' + this.denominazione + ' - ' + this.comune;
  }

}
